if (!customElements.get('agrolix-comparison')) {
  customElements.define('agrolix-comparison', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.cleanup = new AbortController();
      this.effects = new Set();
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!this.classList.contains('ac--motion')) return;
      if (!this.reducedMotion.matches) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('ac__revealed');
            this.observer.unobserve(entry.target);
          });
        }, { threshold: .1 });
        this.querySelectorAll('.ac__intro,.ac__table,.ac__action').forEach(node => this.observer.observe(node));
      }
      this.addEventListener('click', event => {
        const button = event.target.closest('.ac__button');
        if (!button || this.reducedMotion.matches) return;
        const rect = button.getBoundingClientRect();
        const wave = document.createElement('span');
        wave.className = 'ac__click-wave';
        wave.setAttribute('aria-hidden', 'true');
        wave.style.left = `${event.detail ? event.clientX - rect.left : rect.width / 2}px`;
        wave.style.top = `${event.detail ? event.clientY - rect.top : rect.height / 2}px`;
        button.append(wave);
        const animation = wave.animate([
          { transform: 'translate(-50%, -50%) scale(0)', opacity: .6 },
          { transform: `translate(-50%, -50%) scale(${Math.hypot(rect.width, rect.height) / 20})`, opacity: 0 }
        ], { duration: 450, easing: 'ease-out' });
        this.effects.add(animation);
        const remove = () => { wave.remove(); this.effects.delete(animation); };
        animation.finished.then(remove, remove);
      }, { signal: this.cleanup.signal });
    }
    disconnectedCallback() {
      this.cleanup?.abort();
      this.observer?.disconnect();
      this.effects?.forEach(animation => animation.cancel());
    }
  });
}
